var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoNews = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    fill: "none",
    viewBox: "0 0 300 300",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 153.152,
    cy: 144.484,
    r: 80.823,
    fill: "#ECF6EF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.395,
    cy: 89.906,
    r: 5.066,
    fill: "#ECF6EF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.007,
    cy: 57.441,
    r: 9.441,
    fill: "#ECF6EF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.007,
    cy: 196.519,
    r: 8.98,
    fill: "#ECF6EF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.733,
    cy: 187.773,
    r: 8.98,
    fill: "#ECF6EF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.232,
    cy: 197.902,
    r: 4.375,
    fill: "#ECF6EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8ECEA3",
    d: "M151.512 73.618c-.311-.066-.311-.51 0-.576l3.821-.812a.293.293 0 0 0 .226-.226l.823-3.796c.067-.309.508-.309.575 0l.823 3.796a.296.296 0 0 0 .227.226l3.821.812c.31.066.31.51 0 .576l-3.821.812a.296.296 0 0 0-.227.225l-.823 3.797c-.067.309-.508.309-.575 0l-.823-3.796a.293.293 0 0 0-.226-.226l-3.821-.812Zm-93.43 39.952c.12-.567.928-.567 1.048 0l1.456 6.878a.536.536 0 0 0 .41.412l6.813 1.484c.562.123.562.925 0 1.047l-6.813 1.485a.534.534 0 0 0-.41.412l-1.456 6.878c-.12.566-.928.566-1.048 0l-1.456-6.878a.534.534 0 0 0-.41-.412l-6.813-1.485c-.563-.122-.563-.924 0-1.047l6.813-1.484a.535.535 0 0 0 .41-.412l1.456-6.878Zm167.229 23.027c.12-.566.928-.566 1.048 0l.815 3.848a.533.533 0 0 0 .41.412l3.826.834c.563.123.563.924 0 1.047l-3.826.834a.533.533 0 0 0-.41.412l-.815 3.848c-.12.566-.928.566-1.048 0l-.814-3.848a.535.535 0 0 0-.41-.412l-3.827-.834c-.562-.123-.562-.924 0-1.047l3.827-.834a.535.535 0 0 0 .41-.412l.814-3.848Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m243.95 160.063 1.411 6.662 6.567 1.431-6.567 1.431-1.411 6.662-1.41-6.662-6.567-1.431 6.567-1.431 1.41-6.662Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDE4CB",
    d: "m214.403 78.86-96.481 101.777 11.053 43.52 7.598-36.612 77.83-108.686Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8ECEA3",
    strokeWidth: 2.143,
    d: "m117.461 180.176 11.283 44.902 7.139-37.303m-7.369 36.381 29.013-27.402"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECF6EF",
    stroke: "#8ECEA3",
    strokeWidth: 2.143,
    d: "m214.403 78.86-78.06 108.455 61.251 27.401 16.809-135.857Zm0-.922L70.026 159.911l47.435 20.264 96.942-102.238Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ECEA3",
    d: "m158.909 197.684-22.241-9.68-8.154 37.303 30.395-27.623Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoNews);
export { ForwardRef as ReactComponent };
export default "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 300 300\"><circle cx=\"153.152\" cy=\"144.484\" r=\"80.823\" fill=\"#ECF6EF\"></circle><circle cx=\"77.395\" cy=\"89.906\" r=\"5.066\" fill=\"#ECF6EF\"></circle><circle cx=\"114.007\" cy=\"57.441\" r=\"9.441\" fill=\"#ECF6EF\"></circle><circle cx=\"79.007\" cy=\"196.519\" r=\"8.98\" fill=\"#ECF6EF\"></circle><circle cx=\"239.733\" cy=\"187.773\" r=\"8.98\" fill=\"#ECF6EF\"></circle><circle cx=\"222.232\" cy=\"197.902\" r=\"4.375\" fill=\"#ECF6EF\"></circle><path fill=\"#8ECEA3\" d=\"M151.512 73.618c-.311-.066-.311-.51 0-.576l3.821-.812a.293.293 0 0 0 .226-.226l.823-3.796c.067-.309.508-.309.575 0l.823 3.796a.296.296 0 0 0 .227.226l3.821.812c.31.066.31.51 0 .576l-3.821.812a.296.296 0 0 0-.227.225l-.823 3.797c-.067.309-.508.309-.575 0l-.823-3.796a.293.293 0 0 0-.226-.226l-3.821-.812Zm-93.43 39.952c.12-.567.928-.567 1.048 0l1.456 6.878a.536.536 0 0 0 .41.412l6.813 1.484c.562.123.562.925 0 1.047l-6.813 1.485a.534.534 0 0 0-.41.412l-1.456 6.878c-.12.566-.928.566-1.048 0l-1.456-6.878a.534.534 0 0 0-.41-.412l-6.813-1.485c-.563-.122-.563-.924 0-1.047l6.813-1.484a.535.535 0 0 0 .41-.412l1.456-6.878Zm167.229 23.027c.12-.566.928-.566 1.048 0l.815 3.848a.533.533 0 0 0 .41.412l3.826.834c.563.123.563.924 0 1.047l-3.826.834a.533.533 0 0 0-.41.412l-.815 3.848c-.12.566-.928.566-1.048 0l-.814-3.848a.535.535 0 0 0-.41-.412l-3.827-.834c-.562-.123-.562-.924 0-1.047l3.827-.834a.535.535 0 0 0 .41-.412l.814-3.848Z\"></path><path fill=\"#fff\" d=\"m243.95 160.063 1.411 6.662 6.567 1.431-6.567 1.431-1.411 6.662-1.41-6.662-6.567-1.431 6.567-1.431 1.41-6.662Z\"></path><path fill=\"#BDE4CB\" d=\"m214.403 78.86-96.481 101.777 11.053 43.52 7.598-36.612 77.83-108.686Z\"></path><path stroke=\"#8ECEA3\" stroke-width=\"2.143\" d=\"m117.461 180.176 11.283 44.902 7.139-37.303m-7.369 36.381 29.013-27.402\"></path><path fill=\"#ECF6EF\" stroke=\"#8ECEA3\" stroke-width=\"2.143\" d=\"m214.403 78.86-78.06 108.455 61.251 27.401 16.809-135.857Zm0-.922L70.026 159.911l47.435 20.264 96.942-102.238Z\"></path><path fill=\"#8ECEA3\" d=\"m158.909 197.684-22.241-9.68-8.154 37.303 30.395-27.623Z\"></path></svg>";